// Chart modes several question types share by name. The word cloud's is also the value the report
// stores in a question's `cm` param while the block shows its cloud instead of a chart.

export const WC_CHART_MODE = 'wc'

// The modes that draw shares rather than counts.
export const PERCENT_CHART_MODES = ['percents', 'bpercents']

// Which measure a question leaves out: a question that shows percents only has no counts to draw,
// one that shows amounts only has no shares; a block can also carry the flag of its own.
export const calcIgnoreAmount = (format, ignoreAmount = false) => true === format?.percentsOnly || Boolean(ignoreAmount)
export const calcIgnorePercents = (format, ignorePercents = false) =>
  true === format?.amountOnly || Boolean(ignorePercents)

export const isWcChartMode = chartMode => WC_CHART_MODE === chartMode

// The tables-only mode: a block hides its chart for it, so no chart is ever fitted to it.
export const NONE_CHART_MODE = 'none'

// Whether a question shows tables only: the report-wide mode asks for it, which always wins, or the
// question declares it in its data. A reader's own pick is never `none`. Called (declared, reportWide).
export const isNoneChartMode = (...chartModes) => chartModes.includes(NONE_CHART_MODE)

// The mode a question draws in, before it is fitted to what its view offers: the reader's own pick,
// else the mode the question declares in its data, else the report-wide one. Default (`off`) is the
// reader asking to follow the report, so it skips the declared mode too.
export const calcQuestionChartMode = (pick, declared, reportWide) => {
  if ('off' === pick) return reportWide ?? null
  return pick || declared || reportWide || null
}

// Where a chart mode goes when the question does not offer it: the same measure first (counts stay
// counts, shares stay shares), then the same orientation. A pie is a share of counts.
const NEAREST_CHART_MODES = {
  pie: ['respondents', 'percents', 'brespondents', 'bpercents'],
  respondents: ['brespondents', 'percents', 'bpercents'],
  brespondents: ['respondents', 'bpercents', 'percents'],
  percents: ['bpercents', 'respondents', 'brespondents'],
  bpercents: ['percents', 'brespondents', 'respondents']
}

// A question always draws a mode it can: whatever it was handed -- its own pick, the mode it
// declares, the report-wide one, or a stored value no type offers -- ends on one of the modes it
// offers. `keep` names the modes the block draws without a chart of its own (a word cloud).
// A view that offers no modes draws its one fixed chart, so the mode is left to it, as is a missing one.
export const calcDrawableChartMode = (chartMode, offered = [], { globalChartMode = null, keep = [] } = {}) => {
  if (null == chartMode || !offered.length || NONE_CHART_MODE === chartMode || offered.includes(chartMode))
    return chartMode
  if (keep.includes(chartMode)) return chartMode

  const nearest = (NEAREST_CHART_MODES[chartMode] || []).find(mode => offered.includes(mode))
  if (nearest) return nearest

  return offered.includes(globalChartMode) ? globalChartMode : offered[0]
}
